export { default as RegistrationManager } from './RegistrationManager'